import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiArrowDown } = FiIcons;

function HeroSection() {
  const scrollToNext = () => {
    const conceptSection = document.getElementById('concept');
    if (conceptSection) {
      conceptSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      aria-label="首頁主視覺"
    >
      {/* Animated Background - 簡化動畫 */}
      <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
        <motion.div
          className="absolute top-1/4 -left-1/4 w-96 h-96 bg-gradient-to-r from-rose-500/20 to-pink-500/20 rounded-full blur-3xl"
          animate={{
            scale: [1, 1.15, 1],
            opacity: [0.3, 0.4, 0.3],
          }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          className="absolute bottom-1/4 -right-1/4 w-96 h-96 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-full blur-3xl"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.4, 0.3],
          }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>

      <div className="container-custom relative z-10 text-center px-4">
        {/* 🚀 優化：減少初始動畫延遲，更快顯示內容 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          {/* Japanese Title */}
          <motion.div
            className="text-7xl md:text-9xl font-light mb-6 bg-gradient-to-r from-slate-800 via-rose-600 to-purple-600 dark:from-slate-100 dark:via-rose-400 dark:to-purple-400 bg-clip-text text-transparent select-none"
            animate={{
              backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
            }}
            transition={{ duration: 5, repeat: Infinity, ease: "linear" }}
            style={{ backgroundSize: '200% 200%' }}
            aria-hidden="true"
          >
            お任せ
          </motion.div>

          {/* English Title */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="mb-8"
          >
            <h1 className="text-4xl md:text-6xl font-light text-slate-700 dark:text-slate-300 mb-4">
              Omakase
            </h1>
            <p className="text-xl md:text-2xl text-slate-600 dark:text-slate-400 font-light">
              信任的藝術 · 季節的智慧 · 匠人的精神
            </p>
          </motion.div>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="text-lg md:text-xl text-slate-600 dark:text-slate-400 max-w-3xl mx-auto mb-12 leading-relaxed"
          >
            在日本料理的世界中，Omakase 不僅是一種用餐方式，
            <br className="hidden md:block" />
            更是一種文化、一種哲學、一種對美的極致追求
          </motion.p>

          {/* CTA Button */}
          <motion.button
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToNext}
            className="group relative inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white rounded-full font-medium shadow-lg hover:shadow-xl transition-all focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-offset-2"
            aria-label="向下滾動探索更多內容"
          >
            開始探索
            <motion.div
              animate={{ y: [0, 4, 0] }}
              transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
            >
              <SafeIcon icon={FiArrowDown} className="w-5 h-5" />
            </motion.div>
          </motion.button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
        aria-hidden="true"
      >
        <motion.button
          onClick={scrollToNext}
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
          className="flex flex-col items-center gap-2 text-slate-400 dark:text-slate-500 focus:outline-none focus:ring-2 focus:ring-rose-500 rounded p-2"
          aria-label="向下滾動"
        >
          <span className="text-sm font-light">向下探索</span>
          <SafeIcon icon={FiArrowDown} className="w-4 h-4" />
        </motion.button>
      </motion.div>
    </section>
  );
}

export default HeroSection;